<div mat-dialog-title>
    {{'Bank details'| translate}}
    <span class="float-right pointer" (click)="close()">
        <i class="fa fa-times close-btn "></i>
    </span>
    <!-- <span style="float: right;" (click)="close()" ><mat-icon>close</mat-icon>  </span> -->
</div>

<mat-dialog-content>
    <form [formGroup]="bankDetailsForm">
        <div class="row">

            <div class="col-md-6" *ngIf="field_config_access && this.field_config_access['RES_bankNameId']">
                <tm-select [form_group]="bankDetailsForm" [form_control]="'bankNameId'" [design_pattern]="4"
                    [options]="bankList" [label_action_title]="' not found? click here to add'" [label_action_type]="3"
                    [auto_addition]="1" [auto_addition]="1" [auto_data]="bankDetailsForm.value.bankName"
                    [auto_form_control]="'bankName'" [data]="bankDetailsForm.value.bankNameId"
                    [label]="this.field_config_access['RES_bankNameId'].label ||'Bank name' "
                    [placeholder]=" this.field_config_access['RES_bankNameId'].placeholder || '<- -Select- ->' ">
                </tm-select>
            </div>
            <div class="col-md-6" *ngIf="field_config_access && this.field_config_access['RES_bankAccountNumber']">
                <mat-form-field floatLabel="always">
                    <mat-label> {{this.field_config_access['RES_bankAccountNumber'].label || 'Account number'}}
                    </mat-label>
                    <input matInput formControlName="bankAccountNumber"
                        [placeholder]="this.field_config_access['RES_bankAccountNumber'].placeholder || 'Enter bank account number'">
                </mat-form-field>
            </div>
            <div class="col-md-6" *ngIf="field_config_access && this.field_config_access['RES_bankRefCode']">
                <mat-form-field floatLabel="always">
                    <mat-label> {{this.field_config_access['RES_bankRefCode'].label || 'IFSC code'}}
                    </mat-label>
                    <input matInput formControlName="bankRefCode"
                        [placeholder]="this.field_config_access['RES_bankRefCode'].placeholder || 'Enter IFSC code'">
                </mat-form-field>
            </div>

            <div class="col-md-6" *ngIf="field_config_access && this.field_config_access['RES_bankCityId']">
                <tm-select [form_group]="bankDetailsForm" [form_control]="'bankCityId'" [design_pattern]="4"
                    [options]="cityList" [label_action_title]="' not found? click here to add'" [label_action_type]="3"
                    [auto_addition]="1" [auto_data]="bankDetailsForm.value.bankCityName"
                    (selected_obj)="cityChanged($event)" [auto_form_control]="'bankCityName'"
                    [data]="bankDetailsForm.value.bankCityId"
                    [label]="this.field_config_access['RES_bankCityId'].label ||'City' "
                    [placeholder]=" this.field_config_access['RES_bankCityId'].placeholder || '<- -Select- ->' ">
                </tm-select>
            </div>
            <div class="col-md-6" *ngIf="field_config_access && this.field_config_access['RES_bankStateId']">
                <tm-select [form_group]="bankDetailsForm" [form_control]="'bankStateId'" [design_pattern]="4"
                    [options]="stateList" [label_action_title]="' not found? click here to add'" [label_action_type]="3"
                    [auto_addition]="1" [auto_data]="bankDetailsForm.value.bankStateName"
                    [auto_form_control]="'bankStateName'" [data]="bankDetailsForm.value.bankStateId"
                    [label]="this.field_config_access['RES_bankStateId'].label ||'State' "
                    [placeholder]=" this.field_config_access['RES_bankStateId'].placeholder || '<- -Select- ->' ">
                </tm-select>
            </div>
            <div class="col-md-6" *ngIf="field_config_access && this.field_config_access['RES_bankCountryId']">
                <tm-select [form_group]="bankDetailsForm" [form_control]="'bankCountryId'" [options]="countryList"
                    [label_action_title]="' not found? click here to add'" [label_action_type]="3"
                    [auto_data]="bankDetailsForm.value.bankName" [data]="bankDetailsForm.value.bankCountryId"
                    [label]="this.field_config_access['RES_bankCountryId'].label ||'Country' "
                    [placeholder]=" this.field_config_access['RES_bankCountryId'].placeholder || '<- -Select- ->' ">
                </tm-select>
            </div>
            <div class="col-md-6" *ngIf="field_config_access && this.field_config_access['RES_bankPostalCode']">
                <mat-form-field floatLabel="always">
                    <mat-label> {{this.field_config_access['RES_bankPostalCode'].label || 'Postal code'}}
                    </mat-label>
                    <input matInput formControlName="bankPostalCode"
                        [placeholder]="this.field_config_access['RES_bankPostalCode'].placeholder || 'Enter Postal code'">
                </mat-form-field>
            </div>
            <div class="col-md-6" *ngIf="field_config_access && this.field_config_access['RES_bankAttachments']">
                <tm-files-v2 [form_control]="'bankAttachments'" [form_group]="bankDetailsForm"
                    [result]="bankDetailsForm.value.bankAttachments" (uploadStatus)="attachmentUploading($event)"
                    [label]="field_config_access['RES_bankAttachments'].label || 'Bank attachments' "></tm-files-v2>
            </div>
            <div class="col-md-6" *ngIf="field_config_access && this.field_config_access['RES_bankAddressLine1']">
                <mat-form-field floatLabel="always">
                    <mat-label> {{this.field_config_access['RES_bankAddressLine1'].label || 'Addess line 1'}}
                    </mat-label>
                    <textarea matInput formControlName="bankAddressLine1"
                        [placeholder]="this.field_config_access['RES_bankAddressLine1'].placeholder || 'Enter Addess line 1'"></textarea>
                </mat-form-field>
            </div>
            <div class="col-md-6" *ngIf="field_config_access && this.field_config_access['RES_bankAddressLine2']">
                <mat-form-field floatLabel="always">
                    <mat-label> {{this.field_config_access['RES_bankAddressLine2'].label || 'Address line 2'}}
                    </mat-label>
                    <textarea matInput formControlName="bankAddressLine2"
                        [placeholder]="this.field_config_access['RES_bankAddressLine2'].placeholder || 'Enter Addess line 2'"></textarea>
                </mat-form-field>
            </div>

        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions>
    <span style="font-size: 13px !important;" id="tm-popup-notification-window"> </span>

    <button style="min-width: 100px;" class="ml-auto  blob-btn-cancel btn-sm btn mx-1 mx-1 tallite-action"
        (click)="close()">
        {{ 'BTN.cancel' | translate}}
        <span class="blob-btn-cancel__inner">
            <span class="blob-btn-cancel__blobs">
                <span class="blob-btn-cancel__blob"></span>
                <span class="blob-btn-cancel__blob"></span>
                <span class="blob-btn-cancel__blob"></span>
                <span class="blob-btn-cancel__blob"></span>
            </span>
        </span>
    </button>
    <button style="min-width: 100px;" class="blob-btn  btn  btn-sm  mx-1 tallite-action" type="submit" (click)="save()">
        {{ 'Save' | translate }}
        <span class="blob-btn__inner">
            <span class="blob-btn__blobs">
                <span class="blob-btn__blob"></span>
                <span class="blob-btn__blob"></span>
                <span class="blob-btn__blob"></span>
                <span class="blob-btn__blob"></span>
            </span>
        </span>
    </button>
</mat-dialog-actions>